import { TYPES_TESTIMONIAL } from './testimonial.types';

const INITIAL_STATE = {
  list: [],
  loading: false,
};

const testimonialReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TYPES_TESTIMONIAL.GET_TESTIMONIAL_DATA_LOADING:
      return { ...state, loading: action.loading || true };
    case TYPES_TESTIMONIAL.GET_TESTIMONIAL_LIST:
      return { ...state, list: action.payload, loading: false };
    default:
      return state;
  }
};

export default testimonialReducer;
